import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { savePresetFilter } from 'gqlQueries/filterQueries';
import { sendNotification, trimString } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useSavePreset({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    //To fetch dim
    const [savePreset, { data: timePeriod, loading: timePeriodLoading, error: timePeriodError }] = useMutation(
        savePresetFilter,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { listData } = payload;
            onComplete(listData);
            sendNotification('success', 'Preset saved successfully.');
        } catch (error) {
            onFetchError(error);
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setError(error);
        setLoading(false);
        sendNotification('error', trimString(String(error), 'ApolloError:') || errorMessage);
    }

    return {
        loading,
        error,
        savePreset: (variables: any) => {
            setLoading(true);
            savePreset(variables);
        },
    };
}

export default useSavePreset;
